import {
  LIST_FREE_TRIAL_IPB,
  LIST_FREE_TRIAL_IPB_ERROR,
  CLEAN_LIST_FREE_TRIAL_IPB,
  CLEAN_LIST_FREE_TRIAL_IPB_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function listFreeTrialIpbReducer(state = initialState, action) {
  switch (action.type) {
    case LIST_FREE_TRIAL_IPB:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case LIST_FREE_TRIAL_IPB_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_LIST_FREE_TRIAL_IPB:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_LIST_FREE_TRIAL_IPB_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
